// Remove the zIndex import as it's not being used properly
// If you need zIndex values, use numeric values directly or import from theme

const columnConfig = {
  select: {
    id: "select",
    label: "",
    noWrap: true,
    sticky: true,
    width: "50px",
    sortDisabled: true,
  },
  casenumber: {align: "left", width: "120px", sticky: true, zIndex:99 },
  country: { align: "left" },
  blnumber: {align: "left", width: "120px", sortDisabled: true },
  casestatus: { align: "left" },
  sourcename: { align: "left", width: "160px" },
  slastatus: { align: "left" },
  email_subject: { align: "left", width: "250px" },
  caseassignedto: { align: "left", width: "200px" },
   modifiedby: { align: "left", width: "200px" },
  // modifieddate: {align: "left", width: "200px" },
  ie_modifieddate: {align: "left", width: "200px" },
  casestatusreason: {align: "left", width: "200px", sortDisabled: true },
  casetat: { align: "left",width: "190px", sortDisabled: true },
  dacaseprocessingtime: { align: "left",width: "200px", sortDisabled: true },
  slaremainingtime: { align: "left",width: "144px" },
  casereceiveddatetime: { align: "left",width: "200px" },
  casestatusdatetime: {align: "left", width: "200px" },
  createddate: {align: "left", width: "200px" },
  week: { align: "left" },
  countryslatime: { align: "left",width: "100px", sortDisabled: true },
  customername: {align: "left", width: "160px" },
  rulename: { align: "left", width: "200px" },
  afrdata: { align: "left", width: "200px" },
  bookingdata: { align: "left", width: "200px" },
  outcome: { width: "160px" },
  reason: { align: "left", width: "200px" },
};

export const updateHeaders = (headers, hasDates) => {
  const insertAtIndex = 12;
  const newHeaders = [...headers];

  // Always include the select column at the start
  // const selectColumn = {
  //   key: "select",
  //   header: "",
  //   width: "50px",
  //   sticky: true,
  //   sortDisabled: true,
  // };
  // newHeaders.unshift(selectColumn);

  if (hasDates) {
    const additionalHeaders = [{ key: "week", header: "Week", width: "100px" }];
    newHeaders.splice(insertAtIndex, 0, ...additionalHeaders);
  }

  // Add EmailSubject column if not present
  // if (!newHeaders.some(h => h.key === "email_subject")) {
  //   newHeaders.push({ key: "email_subject", header: "EmailSubject", width: "250px" });
  // }

  return newHeaders.map((header) => {
    const config = columnConfig[header.key] || {};
    return { ...header, ...config };
  });
};

export const generateColumns = (headers) => {
  return headers.map((header) => ({
    id: header.key,
    label: header.header,
    width: header.width || "auto",
    align: header.align || "center",
    sticky: header.sticky || false,
    sortDisabled: header.sortDisabled || false,
  }));
};
